export const columns = function () {
  return [
    {
      prop: 'id',
      label: 'ID',
      minWidth: 50
    },
    {
      prop: 'periodical_id',
      label: '期数',
      minWidth: 50,
    },
    {
      prop: 'type',
      label: '分摊类型',
      minWidth: 50
    },
    {
      prop: 'money',
      label: '分摊金额',
      minWidth: 100
    },
    {
      prop: 'createtime',
      label: '创建时间',
      minWidth: 50,
    },
    {
      prop: 'user_name',
      label: '用户名',
      minWidth: 50,
    },
    {
      prop: 'cart_num',
      label: '车牌号码',
      minWidth: 50,
    },
  ]
}


export default {}